import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { validateLegalGuardianApi as API } from '../Apis';

export const ValidateLegalGuardianDocs: IDocs = {
  title: 'ValidateLegalGuardian',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.validateLegalGuardian',
};

const prepareCall = () => API.call.post();

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const smilesMinorLegalGuardian = !!infos?.minor;
  const smilesInvalidLegalGuardian =
    !!infos?.userPreIdentificated || !!infos?.userNotFound;
  const smilesErrorService =
    !smilesMinorLegalGuardian && !smilesInvalidLegalGuardian;

  return {
    smilesErrorService,
    smilesMinorLegalGuardian,
    smilesInvalidLegalGuardian,
  };
};

export const ValidateLegalGuardianMachine = GenericMachine(
  prepareCall,
  {
    docs: ValidateLegalGuardianDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
